import Link from 'next/link';
import { FC, ReactNode } from 'react';

export const SuperstarLink: FC<{
  superstarId: string;
  children: ReactNode;
  onClick?: () => void;
}> = ({ superstarId, children, onClick }) => {
  return (
    <Link
      draggable={false}
      href={`/superstar-database/${superstarId}`}
      onClick={onClick}
    >
      {children}
    </Link>
  );
};
